import logo from './logo.svg';
import './App.css';
import LandingPage from './LandingPage';
import TeachersPage from './TeachersPage';
import AdminPage from './AdminPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import { AuthContextProvider } from './context/AuthContext';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <AuthContextProvider>
      <Routes>
        
        <Route path='/' element={<LandingPage />} />
        <Route path='/teacher' element={<ProtectedRoute><TeachersPage /></ProtectedRoute>} />
        <Route path='/admin' element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path='/admin/audio' element={<ProtectedRoute><AdminPage initialSection="audio" /></ProtectedRoute>} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsOfService />} />
      </Routes>
    </AuthContextProvider>
    
  );
}

export default App;
